export const PRICE_TYPES = {
    SUBSCRIPTION: 'SUBSCRIPTION',
    ONCE: 'ONCE',
};

export const MEDICAL_SERVICE = 'MEDICAL_SERVICE';
export const SPECIALTY = 'SPECIALTY';
